function positiveMs (value) {
	const n = Number(value);
	if (!n || n < 86400000) {
		return 0;
	}
	return n;
}

function activityBound (activity, which) {
	if (!activity) {
		return 0;
	}
	if (which === 'start') {
		return positiveMs(activity.start) || positiveMs(activity.earlyStart) || positiveMs(activity.targetStart);
	}
	return positiveMs(activity.finish) || positiveMs(activity.earlyFinish) || positiveMs(activity.targetFinish);
}

/** Earliest start and latest finish on the loaded activities. */
export function timescaleFromActivities (activities) {
	let start = 0;
	let end = 0;
	const list = Array.isArray(activities) ? activities : [];
	list.forEach(activity => {
		const activityStart = activityBound(activity, 'start');
		const activityFinish = activityBound(activity, 'finish');
		if (activityStart && (!start || activityStart < start)) {
			start = activityStart;
		}
		if (activityFinish && (!end || activityFinish > end)) {
			end = activityFinish;
		}
	});
	if (start && end && end <= start) {
		end = start + 86400000;
	}
	return { start, end };
}

export function hasStoredTimescale (dataset) {
	const start = positiveMs(dataset && dataset.StartDate);
	const end = positiveMs(dataset && dataset.EndDate);
	return Boolean(start && end && end > start);
}

/**
 * Stored project start/end when both are usable. Otherwise the activity dates,
 * so a reload cannot leave the Gantt blank after the activities have loaded.
 */
export function resolveTimescale (dataset, activities) {
	if (hasStoredTimescale(dataset)) {
		return {
			start: positiveMs(dataset.StartDate),
			end: positiveMs(dataset.EndDate),
			source: 'stored'
		};
	}
	const fromActivities = timescaleFromActivities(activities);
	if (fromActivities.start && fromActivities.end) {
		return { start: fromActivities.start, end: fromActivities.end, source: 'activities' };
	}
	return { start: 0, end: 0, source: 'empty' };
}

/** Patch a dataset list entry. persist is true only when the server value was empty. */
export function applyTimescale (dataset, activities) {
	const scale = resolveTimescale(dataset, activities);
	const next = { ...(dataset || {}) };
	if (scale.source === 'activities') {
		next.StartDate = scale.start;
		next.EndDate = scale.end;
	}
	return {
		dataset: next,
		persist: scale.source === 'activities',
		start: scale.start,
		end: scale.end
	};
}

export function utcDay (ms) {
	const n = positiveMs(ms);
	if (!n) {
		return '';
	}
	return new Date(n).toISOString().slice(0, 10);
}
